<template>
  <div class="search-choose-bottom">
    <div style="display: flex">
      <div class="search-choose-tip-desc">排序:</div>
      <a-divider type="vertical" />
      <div
        class="search-choose-tab-item"
        :class="curType == 'createTime' ? 'item-active' : ''"
        @click="clickDesc('createTime')"
      >
        时间<a-icon
          type="arrow-down"
          v-if="
            curType != 'createTime' ||
            (curType == 'createTime' && sortRule == 'desc')
          "
        /><a-icon
          type="arrow-up"
          v-if="curType == 'createTime' && sortRule == 'asc'"
        />
      </div>
      <a-divider type="vertical" />
      <div
        class="search-choose-tab-item"
        :class="curType == 'projectLikeNum' ? 'item-active' : ''"
        @click="clickDesc('projectLikeNum')"
      >
        点赞<a-icon
          type="arrow-down"
          v-if="
            curType != 'projectLikeNum' ||
            (curType == 'projectLikeNum' && sortRule == 'desc')
          "
        /><a-icon
          type="arrow-up"
          v-if="curType == 'projectLikeNum' && sortRule == 'asc'"
        />
      </div>
      <a-divider type="vertical" />
      <div
        class="search-choose-tab-item"
        :class="curType == 'projectName' ? 'item-active' : ''"
        @click="clickDesc('projectName')"
      >
        名称<a-icon
          type="arrow-down"
          v-if="
            curType != 'projectName' ||
            (curType == 'projectName' && sortRule == 'desc')
          "
        /><a-icon
          type="arrow-up"
          v-if="curType == 'projectName' && sortRule == 'asc'"
        />
      </div>
      <a-divider type="vertical" />
    </div>

    <div class="button-div">
      <a-button
      v-if="addPageText"
        @click="addPage"
        style="margin-right: 10px"
        class="button-class"
        type="primary"
      >
        {{ addPageText }}
      </a-button>
      <a-button
        @click="editProjects"
        style="margin-right: 10px"
        class="button-class"
        type="primary"
      >
        {{ editOrDelet }}
      </a-button>
      <a-button class="button-class" type="primary" style="margin-right: 10px" @click="addProject">{{
        addOrCancel
      }}</a-button>
      <a-upload
        name="file"
        accept=".zip"
        :multiple="false"
        action="/api/design/project/importProject"
        :headers="headers"
        :beforeUpload="beforeUpload"
        @change="handleChange"
        :showUploadList="false"
      >
        <a-button v-if="isProjectList" class="button-class" type="primary">
          项目导入
        </a-button>
      </a-upload>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  TOKEN
} from "@/store/mutation-types";
export default {
  name: "sort",
  props: {
    editStatus: {
      type: Boolean,
    },
    addOrCancel: {
      type: String,
    },
    editOrDelet: {
      type: String,
    },
    curType: {
      type: String,
    },
    sortRule: {
      type: String,
    },
    addPageText :{
      type:String
    },
    isProjectList: Boolean
  },
  data() {
    return {
      headers: {
        "X-Bd-Access-Token": Vue.ls.get(TOKEN)
      },
      hide: null
    };
  },
  watch: {
    activeKey(key) {
      console.log(key);
    },
  },
  mounted() {},
  methods: {
    editProjects() {
      this.$emit("editProjects");
    },
    clickDesc(curType) {
      let self = this;
      self.$emit("changeCurType", curType);
    },
    addProject() {
      this.$emit("addProject");
    },
    addPage(){
      this.$emit("addPage");
    },
    beforeUpload(){
      this.hide = this.$message.loading("文件导入中...", 0)
    },
    handleChange(info){
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        this.hide()
        this.$message.success(`${info.file.name}导入成功`);
      } else if (info.file.status === 'error') {
        this.hide()
        this.$message.error(`${info.file.name}导入失败`);
      }
    }
  },
};
</script>
<style lang="less" scoped>
@import "./sort.less";
</style>